module.exports = __webpack_public_path__ + "media/images/patient-icons/financial-icon-cb788e3d73d6e63c6aaf45bd587b4c9c.svg";